import { PropsWithChildren, useState } from 'react'
import cn from 'classnames'

import Typography from '~/components/Typography'

import styles from './Tabs.pcss'

type TabItem<T> = { id: T; name: string }

interface Props<T> {
	tabs: TabItem<T>[]
	defaultActive?: T
	onChange?: (tab: TabItem<T>) => void
}

function Tabs<T>({
	defaultActive,
	tabs,
	onChange = () => {},
}: PropsWithChildren<Props<T>>) {
	const [activeKey, setActiveKey] = useState<T>(defaultActive)

	const handleClick = (tab: TabItem<T>) => {
		setActiveKey(tab.id)
		onChange(tab)
	}

	return (
		<ul className={styles.tabs}>
			{tabs.map((tab, idx) => (
				<li
					key={idx}
					className={cn(
						styles.item,
						activeKey === tab.id && styles.active
					)}
					onClick={() => handleClick(tab)}
				>
					<Typography>{tab.name}</Typography>
				</li>
			))}
		</ul>
	)
}

export default Tabs
